// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DebitCardMapStatus } from './debitCardMapStatus.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DebitCardMapResponseModel {
    'debitCardMapStatus'?: DebitCardMapStatus;
    'debitCardLast4'?: string;
    'isActive'?: boolean;
    'isPending'?: boolean;
    'memberNumber'?: string;
    'accountNumber'?: string;
    'subId'?: string;
    'subIdTypeCode'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DebitCardMapResponseModel>> = [
        {
            "name":     "debitCardMapStatus",
            "baseName": "debitCardMapStatus",
            "type":     "DebitCardMapStatus"
        },
        {
            "name":     "debitCardLast4",
            "baseName": "debitCardLast4",
            "type":     "string"
        },
        {
            "name":     "isActive",
            "baseName": "isActive",
            "type":     "boolean"
        },
        {
            "name":     "isPending",
            "baseName": "isPending",
            "type":     "boolean"
        },
        {
            "name":     "memberNumber",
            "baseName": "memberNumber",
            "type":     "string"
        },
        {
            "name":     "accountNumber",
            "baseName": "accountNumber",
            "type":     "string"
        },
        {
            "name":     "subId",
            "baseName": "subId",
            "type":     "string"
        },
        {
            "name":     "subIdTypeCode",
            "baseName": "subIdTypeCode",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return DebitCardMapResponseModel.attributeTypeMap;
    }
}
